import React, { Component } from 'react'
import BookingInput from '../Booking/bookinginput';
import {connect} from "react-redux";
import ButtonLoader from "../btnloader";
import { ajaxerrmsg } from '../../actions/http';
import {storeLogin} from "../../actions/storeActions"
import {addToast, openModal } from "../../actions"

class StoreLogin extends Component {

    state = {
        username: '',
        username_err: '',
        password: '',
        password_err: ''
    }

    componentDidMount(){
        setTimeout(() => {
            this.props.openModal('HOW_IT_WORKS');
        }, 500)
    }

    handleChange = (e) => {
        let {value, name} = e.target;
        this.setState({
            [name]: value,
            [name + "_err"]: ''
        })
    }
    
    handleSubmit = (e) =>{
        e.preventDefault();
        let client = Math.random() * 10000;
        let {username,password} = this.state;
        if(username.length !== 10){
            this.setState({
                username_err: 'Invalid mobile number'
            });
            return;
        }
        if(password.length < 6){
            this.setState({
                password_err: 'Password must be atleast 6 characters'
            });
            return;
        }
        this.props.storeLogin({username, password, client, role: 3});
    }

    componentDidUpdate(prevProps){
        let {user, addToast} = this.props;
        if(user.error && !prevProps.user.error){
            addToast(ajaxerrmsg(user.error), false);
        }
    }

    render() {
        let {username, username_err, password, password_err} = this.state;
        let {fetching} = this.props.user;
        return (
            <div className="container-fluid">
                <form onSubmit={this.handleSubmit} autoComplete="off" noValidate style={{width: `100%`}}>
                    <div className="flex-center">
                        <h2 className="text-center f-600 header-underline">Store Login</h2>
                    </div>
                    <div className="row m-t-20">
                        <div className="col-md-12">
                            <div className="row">
                                <BookingInput 
                                    size={12} 
                                    name="username" 
                                    value={username} 
                                    onChange={this.handleChange}
                                    err={username_err} 
                                    type="number"
                                    maxLength={10} 
                                    placeholder="Mobile number"
                                />
                                <BookingInput 
                                    size={12} 
                                    name="password" 
                                    value={password} 
                                    onChange={this.handleChange}
                                    err={password_err} 
                                    type="password" 
                                    placeholder="Password"
                                />
                                <div className="col-md-12 m-b-10">
                                    <button 
                                        type="submit"
                                        disabled={username && password && !fetching ? false : true}
                                        className="btn btn-ouja btn-block"
                                        onSubmit={this.handleSubmit}
                                    >
                                        {fetching ? <ButtonLoader /> : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = ({loginReducer}) => ({
    user: loginReducer
})

const mapDispatchToProps = {
    storeLogin, addToast, openModal
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreLogin)
